import React from "react";
import Spin from "./common/Spin";

const LoadingBar = ({ loading = false, label = "Loading" }) => {
  if (!loading) return null;

  return (
    <div className="fixed p-0 m-0 w-screen h-screen z-[9999] top-0 left-0 flex justify-center items-center">
      <div className="relative w-40 h-40 flex flex-col gap-y-2.5 justify-center items-center rounded-xl bg-[#88888860]">
        <div className="w-10 h-10 text-primary">
          {/* Spin component should be implemented separately */}
          <Spin />
        </div>
        <div className="mt-4 font-bold text-base text-secondary-text">{label}</div>
      </div>
    </div>
  );
};

export default LoadingBar;
